import {
  GeoJsonLayer,
  PolygonLayer,
  Position,
  RGBAColor,
  TextLayer,
} from 'deck.gl';
import { Feature } from 'geojson';
import center from '@turf/center';
import { polygon,  } from '@turf/helpers';
export interface IPolygonLayer {
  id: string;
  coordinates: Position[] | Position;
  lineColor: RGBAColor;
  color: RGBAColor;
  name?: string
  value?: string;
}

export interface IUploadedLayer {
  id: string;
  features: Feature<any, any>[];
  color: RGBAColor;
}

export function DatasetZoneLayer(data: IPolygonLayer[]) : PolygonLayer<IPolygonLayer>{
  const layer = new PolygonLayer({
    id: 'polygon-layer',
    data,
    pickable: true,
    stroked: true,
    filled: false,
    wireframe: true,
    lineWidthMinPixels: 1.5,
    getPolygon: (d: any) => d.coordinates,
    getElevation: 0,
    getFillColor: (d: any) => d.color,
    getLineColor: (d: any) => d.lineColor,
    extruded: false,
  });

  return layer as PolygonLayer<IPolygonLayer>
}

export function GlobalDatasetZoneLayer(data: IPolygonLayer[]) : PolygonLayer<IPolygonLayer> {
  const polygonLayer = new PolygonLayer({
    id: 'global-polygon-layer',
    data,
    pickable: true,
    stroked: true,
    filled: false,
    wireframe: true,
    lineWidthMinPixels: 1.5,
    getPolygon: (d: any) => d.coordinates,
    getElevation: 0,
    getFillColor: (d: any) => d.color,
    getLineColor: (d: any) => d.lineColor,
    extruded: false,
  });

  return polygonLayer as PolygonLayer<IPolygonLayer>
}

export function SurfaceMapLayer(data: IPolygonLayer[]): PolygonLayer<IPolygonLayer> {
  const layer = new PolygonLayer({
    id: 'surface-map-layer',
    data,
    pickable: true,
    stroked: true,
    filled: true,
    wireframe: true,
    lineWidthMinPixels: 3,
    getPolygon: (d: any) => d.coordinates,
    getElevation: 0,
    getFillColor: (d: any) => d.color,
    getLineColor: (d: any) => d.lineColor,
    extruded: false,
  });

  return layer as PolygonLayer<IPolygonLayer>
}
export function SelectedZoneLayer(data: IPolygonLayer[]) : PolygonLayer<IPolygonLayer> {
  const layer = new PolygonLayer({
    id: 'selected-polygon-layer',
    data,
    pickable: true,
    stroked: true,
    filled: false,
    wireframe: true,
    lineWidthMinPixels: 3,
    getPolygon: (d: any) => d.coordinates,
    getElevation: 0,
    getFillColor: (d: any) => d.color,
    getLineColor: (d: any) => d.lineColor,
    extruded: false,
  });

  return layer as PolygonLayer<IPolygonLayer>
}

export function FeatureCollectionLayer(
  uploadedFeatures: IUploadedLayer[],
  visibleUploads: Array<string>
) {
  return uploadedFeatures
    .filter((layer: IUploadedLayer) => visibleUploads.includes(layer.id))
    .map((layer: IUploadedLayer) => {
      return new GeoJsonLayer({
        id: layer.id,
        data: layer.features,
        pickable: false,
        stroked: true,
        filled: true,
        extruded: false,
        lineWidthMinPixels: 3,
        pointType: 'circle',
        getFillColor: (f: any) =>
          f.geometry.type === 'Point' ? layer.color : [0, 0, 0, 0],
        getLineColor: layer.color,
        getLineWidth: 1,
        getRadius: 1000,
      });
    });
}

export function GraticuleLayer(
  graticule: GeoJSON.Feature<GeoJSON.LineString>[]
) {
  return new GeoJsonLayer({
    id: 'graticule-layer',
    data: graticule, //Graticule.features,
    pickable: false,
    stroked: true,
    filled: true,
    extruded: false,
    lineWidthMinPixels: 1,
    getFillColor: [0, 0, 0, 0],
    getLineColor: [119, 136, 153],
    getLineWidth: 0.5,
  });
}
